// Checks if localStorage is usable for app state, auth, and user preferences.
export function checkLocalStorage(): {
  isAvailable: boolean;
  error?: string;
} {
  try {
    // Check if localStorage exists
    if (typeof window === 'undefined' || !window.localStorage) {
      return {
        isAvailable: false,
        error: 'localStorage is not supported in this browser.',
      };
    }

    // Try to write to localStorage
    const testKey = '__localStorage_test__';
    window.localStorage.setItem(testKey, 'test');
    const retrieved = window.localStorage.getItem(testKey);
    window.localStorage.removeItem(testKey);

    if (retrieved !== 'test') {
      return {
        isAvailable: false,
        error: 'localStorage write/read test failed.',
      };
    }

    return { isAvailable: true };
  } catch (error) {
    // Handle SecurityError (private browsing, third-party restrictions)
    if (error instanceof DOMException && error.name === 'SecurityError') {
      return {
        isAvailable: false,
        error:
          'localStorage access denied. Enable third-party data storage in browser settings.',
      };
    }

    // Handle QuotaExceededError
    if (error instanceof DOMException && error.name === 'QuotaExceededError') {
      return {
        isAvailable: false,
        error: 'localStorage is full.',
      };
    }

    return {
      isAvailable: false,
      error:
        error instanceof Error
          ? error.message
          : 'Unknown error checking localStorage.',
    };
  }
}
